



























import { defineComponent } from '@vue/composition-api';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { syncedRef } from '@front-app/util/reactivity';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import ContactUsLink from '@front-app/components/ContactUsLink.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { STEP_PROPS } from './steps';

export default defineComponent({
	components: {
		LoaderState,
		ErrorCard,
		SuccessCard,
		ContactUsLink,
		CtaButton,
	},
	props: STEP_PROPS,
	setup(props) {
		const {
			isLoading,
			isError,
			isSuccess,
		} = useAsyncStatus(syncedRef(() => props.status).ref);
		return {
			isLoading,
			isError,
			isSuccess,
		};
	},
});
